module.exports = __webpack_public_path__ + "static/media/experience.88ec56c9.svg";